/**
 * Copyright since 2007 PrestaShop SA and Contributors
 * PrestaShop is an International Registered Trademark & Property of PrestaShop SA
 *
 * NOTICE OF LICENSE
 *
 * This source file is subject to the Open Software License (OSL 3.0)
 * that is bundled with this package in the file LICENSE.md.
 * It is also available through the world-wide-web at this URL:
 * https://opensource.org/licenses/OSL-3.0
 * If you did not receive a copy of the license and are unable to
 * obtain it through the world-wide-web, please send an email
 * to license@prestashop.com so we can send you a copy immediately.
 *
 * DISCLAIMER
 *
 * Do not edit or add to this file if you wish to upgrade PrestaShop to newer
 * versions in the future. If you wish to customize PrestaShop for your
 * needs please refer to https://devdocs.prestashop.com/ for more information.
 *
 * @author    PrestaShop SA and Contributors <contact@prestashop.com>
 * @copyright Since 2007 PrestaShop SA and Contributors
 * @license   https://opensource.org/licenses/OSL-3.0 Open Software License (OSL 3.0)
 */
import $ from 'jquery';
import prestashop from 'prestashop';
import setUpAddress from './checkout-address'
import setUpDelivery from './checkout-delivery'
import setUpPayment from './checkout-payment'
import Steps from './checkout-steps'

function setUpCheckout() {
  setUpAddress();
  setUpDelivery();
  setUpPayment();

  handleCheckoutStepChange();
  handleSubmitButton();
}

function handleCheckoutStepChange() {
  const steps = new Steps();
  const clickableSteps = steps.getClickableSteps();

  clickableSteps.on(
    'click',
    (event) => {
      const clickedStep = Steps.getClickedStep(event);
      /* Cacher la livraison avant le step choix de livraison*/
      var id_step = $(clickedStep['$step']['0']).attr('id');

      removeClassHiddenShipping(id_step);
      minLivraison(id_step)
      if (!clickedStep.isUnreachable()) {
        steps.makeCurrent(clickedStep);
        if (clickedStep.hasContinueButton()) {
          clickedStep.disableAllAfter();
        } else {
          clickedStep.enableAllBefore();
        }
      }
      prestashop.emit('changedCheckoutStep', { event });
    });

  var id_step = $('.checkout-step.-current').attr('id');

  removeClassHiddenShippingOnLoad(id_step);
  minLivraison(id_step)
}

function removeClassHiddenShipping(id_step) {
  if (id_step == "checkout-delivery-step" || id_step == "checkout-payment-step") {
    if (typeof (window.show_price) !== 'undefined' && window.show_price != '1') {
      if ($("#cart-subtotal-shipping").hasClass('hidden-shipping')) {
        setInterval(function () {
          $("#cart-subtotal-shipping").removeClass('hidden-shipping')
        }, 1000);
      }
    }
  } else {
    $("#cart-subtotal-shipping").addClass('hidden-shipping')
  }
}
function removeClassHiddenShippingOnLoad(id_step) {
  if (id_step == "checkout-delivery-step" || id_step == "checkout-payment-step") {
    if (typeof (window.show_price) !== 'undefined' && window.show_price != '1') {
      $("#cart-subtotal-shipping").removeClass('hidden-shipping')
    }
  }
}

function minLivraison(id_step) {
  if (id_step != "checkout-delivery-step" && id_step != "checkout-payment-step" && window.show_price == '1') {

    const currentPath = window.location.pathname;
    var lang = ($('html').attr('lang') || 'en').substring(0, 2).toLowerCase();
    if (currentPath.includes('/fr/') || currentPath.startsWith('/fr')) {
      lang = 'fr';
    } else if (currentPath.includes('/es/') || currentPath.startsWith('/es')) {
      lang = 'es';
    } else if (currentPath.includes('/en/') || currentPath.startsWith('/en')) {
      lang = 'en';
    }

    const translations = {
      'fr': {
        'shipping_from': 'Livraison à partir de',
        'delivery': 'Livraison'
      },
      'en': {
        'shipping_from': 'Shipping from',
        'delivery': 'Delivery'
      },
      'es': {
        'shipping_from': 'Envío desde',
        'delivery': 'Entrega'
      }
    };

    if (!isNaN(parseFloat($('#cart-subtotal-shipping > .value').text()))) {
      $('#cart-subtotal-shipping .label').text(translations[lang].shipping_from);
    } else {
      $('#cart-subtotal-shipping .label').html(`${translations[lang].delivery} <svg xmlns="http://www.w3.org/2000/svg" width="11" height="7" viewBox="0 0 11 7" fill="none">
                <path d="M10 6L5.5 1L1 6" stroke="#151515" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>`);
    }
  }
}

function handleSubmitButton() {
  // prevents rage clicking on submit button and related issues
  const formSelector = '.checkout-step form';
  $(formSelector).submit(function (e) {
    if ($(this).data('disabled') === true) {
      e.preventDefault();
    }
    $(this).data('disabled', true);
    $('button[type="submit"]', this).addClass('disabled');
  });
}

$(document).ready(() => {
  if ($('#checkout').length === 1) {
    setUpCheckout();
  }
});
